import { dashboard } from "../../services/mainService";
import "./Dashboard.css";
import {
  IndianRupee,
  HeartHandshake,
  AlertTriangle,
  BadgeCheck,
} from "lucide-react";
import { useEffect, useState } from "react";

const Dashboard = () => {
  const [data, setdata] = useState({});
  const [action, setaction] = useState([]);

  useEffect(() => {
    fetchdata();
  }, []);

  const fetchdata = async () => {
    try {
      const res = await dashboard();
      console.log(res);
      setdata(res.data);
      setaction(res.action_required);
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
    } finally {
    }
  };

  return (
    <div className="dashboard">
      {/* Page Title */}
      <div className="page-header">
        <h2>Dashboard</h2>
        <p>Overview of platform activity</p>
      </div>

      {/* Stats */}
      <div className="stats-grid">
        <StatCard
          icon={<IndianRupee />}
          title="Total Donations"
          value={`₹${data.total_donations || 0}`}
        />
        <StatCard
          icon={<HeartHandshake />}
          title="Active Causes"
          value={data.active_causes}
        />
        <StatCard
          icon={<BadgeCheck style={{ color: "#dcb826" }} />}
          title="Pending Verifications"
          value={data.pending_verifications}
        />
        <StatCard
          icon={<AlertTriangle style={{ color: "#dc2626" }} />}
          title="Fraud Marked"
          value={data.fraud_marked}
        />
      </div>

      {/* Middle Section */}
      <div className="dashboard-grid">
        {/* Actions */}
        <div className="card">
          <h3>Action Required</h3>
          <ul className="action-list">
            {action.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        {/* Chart Placeholder */}
        <div className="card">
          <h3>Donations Overview</h3>
          <div className="chart-placeholder">Chart Coming Soon</div>
        </div>
      </div>

      {/* Recent Activity */}
      {/* <div className="card">
        <h3>Recent Activity</h3>
        <ul className="activity-list">
          <li>₹5,000 donated to Education Cause</li>
          <li>Water Aid cause verified</li>
          <li>New volunteer registered</li>
        </ul>
      </div> */}
    </div>
  );
};

export default Dashboard;

/* Reusable Stat Card */
const StatCard = ({ icon, title, value, highlight, danger }) => {
  return (
    <div
      className={`stat-card 
      ${highlight ? "highlight" : ""} 
      ${danger ? "danger" : ""}`}
    >
      <div className="icon">{icon}</div>
      <div>
        <p>{title}</p>
        <h4>{value}</h4>
      </div>
    </div>
  );
};
